module.exports = "/app/main/img/int_form_tips.0411cfe4.png";